import { useEffect, useState, useRef } from "react";
import urls from "../../api/urls.json";
import { authorizedHttpGet, authorizedHttpPost } from "../../api/httpCalls";
import styled, { css } from 'styled-components';
import '../styles/FeedAutoCurated.css'
import Loader from "../Loader";
import crop_icon from '../../assests/crop.png';
import { convertTimestampToFormattedDate, getSafeMediaUrl } from '../../utils';
import delete_image from '../../assests/delete_image.png';
import restore from '../../assests/restore.png';
import heart from '../../assests/heart.png';
import chrome_icon from '../../assests/chrome_icon.png';
import CropImage from '../CropImage';
import EmptyView from "../EmptyView";
import no_image_available from '../../assests/placeholder_image.png';
import verified_icon from '../../assests/verified.svg';
import LeftNav from "../LeftNav";
import previous_inctive from '../../assests/arrow_back_grey.png';
import next_inactive from '../../assests/arrow_forward_grey.png';
import previous_active from '../../assests/arrow_back.png';
import next_active from '../../assests/arrow_forward.png';
import { BaseButton } from "../../styles/ButtonStyles";
import PageModal from "../modals/PageModal";
import { useLocation, useNavigate } from "react-router-dom";
import { uploadCroppedImageToS3 } from "../../api/imageUpload";
import ShareRefControl from "../ShareRefControl";


const SelectedView = styled.button`
  width: 40px;
  height: 40px;
  border-radius: 20px;
  border: solid 2px #484848;
  color: #ffffff;
  background-color: #ffffff;
  margin-top: 20px;
  font-size: 20px;
  ${props =>
        props.selected &&
        css`
      background-color: #484848;
    `}
`;

const getTodayDateValue = () => {
    const now = new Date();
    const timezoneOffsetMs = now.getTimezoneOffset() * 60000;
    return new Date(now.getTime() - timezoneOffsetMs).toISOString().split('T')[0];
};

const FeedAutoCurated = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const authToken = localStorage.getItem('authToken');
    const isOtpVerified = localStorage.getItem('verificationPassed');
    if (!authToken || !isOtpVerified) {
        sessionStorage.setItem('redirectUrl', location.pathname)
        navigate('/login')
    }
    const isIpad = window.innerWidth === 1180;
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const totalPages = useRef(1);
    const [currentTab, setCurrentTab] = useState("Approved");
    const [feedData, setFeedData] = useState([]);
    const [showCropImage, setShowCropImage] = useState(false);
    const [cropPhoto, setCropPhoto] = useState('');
    const dragOverItem = useRef();
    const dragImageUrl = useRef();
    const [appName, setAppName] = useState(localStorage.getItem('appName'))
    const [approvedProfiles, setApprovedProfiles] = useState([]);
    const [disapprovedProfiles, setDisapprovedProfiles] = useState([]);
    const [inappropriatedProfiles, setInappropriatedProfiles] = useState([]);
    const [displayPageModal, setDisplayPageModal] = useState(false);
    const [photosetSelected, setPhotosetSelected] = useState(false);
    const [selectedDate, setSelectedDate] = useState('');
    const sharingSourceTabByAutoTab = {
        Approved: "Autofeed-approved",
        Disapproved: "Autofeed-disapproved",
        Inappropriated: "Autofeed-inappropriate",
    };

    const handleLeftNavAppChange = (name) => {
        setAppName(name)
    };

    const selectphotoSet = (e) => {
        const profileDetails = e.target.id.split('-');
        const ref = profileDetails[0];
        const profileIndex = profileDetails[1];
        const photoSet = profileDetails[2];
        const currentProfile = feedData[profileIndex];

        clearSelectedPhotoset(ref, profileIndex);


        const selectedPhotoset = document.getElementById(e.target.id);
        selectedPhotoset.style.backgroundColor = "#484848";
        currentProfile.selectedPhotoset = photoSet;
        const updatedFeedData = [...feedData];
        updatedFeedData[profileIndex] = currentProfile;
        setFeedData(updatedFeedData);
    }

    const clearSelectedPhotoset = (ref = null, profileIndex = null) => {
        if (ref === null && profileIndex === null) {
            const elements = document.getElementsByClassName("auto-selected-photoset");
            Array.from(elements).forEach((element) => {
                element.style.backgroundColor = "rgb(255, 255, 255)"
            })

            return;
        }

        [
            document.getElementById(`${ref}-${profileIndex}-hive_curated_photos`),
            document.getElementById(`${ref}-${profileIndex}-photos`)
        ].forEach((element) => {
            if (element === null) {
                return;
            }
            element.style.backgroundColor = "rgb(255, 255, 255)"
        })
    }

    const checkIfPhotosetIsSelected = () => {
        const res = feedData.map((item) => {
            if (item.hasOwnProperty('selectedPhotoset') && item.selectedPhotoset.length <= 0) {
                return []
            }

            return true
        })
    }

    const fetchAutoCuratedFeed = async () => {
        setApprovedProfiles([]);
        setDisapprovedProfiles([]);
        setInappropriatedProfiles([]);
        setLoading(true);
        let params = { page: page, profile_state: headerTab[currentTab], type: 'auto_curate' }
        if (selectedDate) {
            params.date = selectedDate;
        }
        let response = await authorizedHttpGet(urls.GET_FEED, params)
        if (response.status) {
            totalPages.current = response.data.total_pages;
            setFeedData(response.data.profile_list);
            if (currentTab === 'Approved') {
                setApprovedProfiles(response.data.profile_list);
                setDisapprovedProfiles([]);
                setInappropriatedProfiles([]);
            } else if (currentTab === 'Disapproved') {
                setDisapprovedProfiles(response.data.profile_list);
                setApprovedProfiles([]);
                setInappropriatedProfiles([]);
            } else {
                setInappropriatedProfiles(response.data.profile_list);
                setApprovedProfiles([]);
                setDisapprovedProfiles([]);
            }
        }
        setLoading(false);
    }

    useEffect(() => {
        fetchAutoCuratedFeed()
    }, [page, currentTab, appName, selectedDate])

    const headerTab = {
        "Approved": "approved",
        "Disapproved": "disapproved",
        "Inappropriated": "inappropriated"
    }


    const handleTabChange = (tab) => {
        setCurrentTab(tab)
        setPage(1)
    }

    const handleDateChange = (e) => {
        setSelectedDate(e.target.value);
        setPage(1);
    }

    const handleDateReset = () => {
        setSelectedDate('');
        setPage(1);
    }

    const openGoogleImages = (imageUrl) => {
        navigator.clipboard.writeText(imageUrl);
        window.open('https://www.google.com/imghp', '_blank');
    }

    const setPhotoSelected = (profileIndex, photoIndex, photoSet) => {
        // clearSelectedPhotoset(feedData[profileIndex].ref, profileIndex);
        const currentProfile = feedData[profileIndex];
        currentProfile[photoSet] = currentProfile[photoSet].map((photo) => ({ ...photo, selected: false }));
        currentProfile[photoSet][photoIndex].selected = true;
        const updatedFeedData = [...feedData];
        updatedFeedData[profileIndex] = currentProfile;
        setFeedData(updatedFeedData);
    }

    const showImageCrop = (photo, index, ref, photoSet, profileIndex) => {
        // clearSelectedPhotoset(ref, profileIndex);
        setCropPhoto(photo)
        setShowCropImage(true);
        sessionStorage.setItem('autoCropRef', ref)
        sessionStorage.setItem('autoCropIndex', index)
        sessionStorage.setItem('autoCropPhotoSet', photoSet)
    }

    const saveCroppedImage = (croppedImage) => {
        // const ref = sessionStorage.getItem('autoCropRef');
        // const index = sessionStorage.getItem('autoCropIndex');
        // const photoSet = sessionStorage.getItem('autoCropPhotoSet');
        // feedData.forEach((item) => {
        //     if (item.ref === ref) {
        //         item[photoSet][index]['photo'] = croppedImage;
        //         item[photoSet][index]['photo_id'] = null;
        //     }
        // })
        // setFeedData([...feedData]);
        // setShowCropImage(false);
        // sessionStorage.removeItem('autoCropRef');
        // sessionStorage.removeItem('autoCropIndex');
        // sessionStorage.removeItem('autoCropPhotoSet');
        // const profile = feedData.find((item) => item.ref === ref);
        // updateProfileImages(profile, photoSet);
        saveCroppedImageWithPresignedUrl(croppedImage);
    }

    const saveCroppedImageWithPresignedUrl = async (croppedImage) => {
        console.log('Saving cropped image to S3...');
        const ref = sessionStorage.getItem('autoCropRef');
        const index = sessionStorage.getItem('autoCropIndex');
        const photoSet = sessionStorage.getItem('autoCropPhotoSet');
        try {
            setLoading(true);
            const s3Url = await uploadCroppedImageToS3(croppedImage, ref);
            feedData.forEach((item) => {
                if (item.ref === ref) {
                    item[photoSet][index]['photo'] = s3Url;
                    item[photoSet][index]['photo_id'] = null;
                }
            })
            setFeedData([...feedData]);
            setShowCropImage(false);
            sessionStorage.removeItem('autoCropRef');
            sessionStorage.removeItem('autoCropIndex');
            sessionStorage.removeItem('autoCropPhotoSet');
            const profile = feedData.find((item) => item.ref === ref);
            updateProfileImages(profile, photoSet);
        } catch (e) {
            console.error('Failed to save cropped image', e);
        } finally {
            setLoading(false);
        }
    }

    const updateProfileImages = (profile, photoSet) => {
        approvedProfiles.forEach((item) => {
            if (item.ref === profile.ref) {
                item[photoSet] = profile[photoSet];
            }
        })
        setApprovedProfiles([...approvedProfiles]);
        disapprovedProfiles.forEach((item) => {
            if (item.ref === profile.ref) {
                item[photoSet] = profile[photoSet];
            }
        })
        setDisapprovedProfiles([...disapprovedProfiles]);
        inappropriatedProfiles.forEach((item) => {
            if (item.ref === profile.ref) {
                item[photoSet] = profile[photoSet];
            }
        })
        setInappropriatedProfiles([...inappropriatedProfiles]);
    }

    const deleteImages = (profileIndex, photoIndex, photoSet) => {
        // clearSelectedPhotoset(feedData[profileIndex].ref, profileIndex);
        const currentProfile = feedData[profileIndex];
        if (currentProfile[photoSet].length === 1) {
            return;
        }
        currentProfile[photoSet] = currentProfile[photoSet].filter((photo, index) => index !== photoIndex);
        const updatedFeedData = [...feedData];
        updatedFeedData[profileIndex] = currentProfile;
        setFeedData(updatedFeedData);
    }

    const restoreImage = (profileIndex, photoIndex, photoSet) => {
        // clearSelectedPhotoset(feedData[profileIndex].ref, profileIndex);
        setFeedData(feedData.map((item, index) => {
            if (index === profileIndex) {
                item[photoSet][photoIndex].can_save = !item[photoSet][photoIndex].can_save;
                console.log(item[photoSet][photoIndex])
            }
            return item;
        }
        ));
    }

    const dragStart = (e, position, url, photoset) => {
        dragImageUrl.current = {url, photoset};
        dragOverItem.current = position;
    };

    const dragEnter = (e, position) => {
        dragOverItem.current = position;
    };

    const dropImage = (ref, photoSet) => {
        if (dragOverItem.current !== null && dragImageUrl.current.photoset === photoSet) {
            feedData.forEach((item) => {
                if (item.ref === ref) {
                    item[photoSet][dragOverItem.current] = { "photo": dragImageUrl.current.url, can_save: true, hive_deleted: false, hive_delete_reason: '' };
                }
            })
            setFeedData([...feedData]);
            dragImageUrl.current = null;
            dragOverItem.current = null;
        }
    }

    const handlePageChange = (direction) => {
        if (direction === 'next') {
            if (page < totalPages.current) {
                setPage(parseInt(page) + 1);
            }
        } else {
            if (page > 1) {
                setPage(parseInt(page) - 1);
            }
        }

    }
    

    const checkIfRefExists = (ref, type) => {
        let exists = false;
        if (type === 'approve') {
            approvedProfiles.forEach((item) => {
                if (item.ref === ref) {
                    exists = true;
                }
            })
        } else if (type === 'disapp') {
            disapprovedProfiles.forEach((item) => {
                if (item.ref === ref) {
                    exists = true;
                }
            })
        } else {
            inappropriatedProfiles.forEach((item) => {
                if (item.ref === ref) {
                    exists = true;
                }
            })
        }
        return exists;
    }

    const handleAction = (profile, action) => {
        if (action === 'approve') {
            if (checkIfRefExists(profile.ref, 'approve')) {
                const remove_profile = approvedProfiles.filter((item) => item.ref !== profile.ref);
                setApprovedProfiles(remove_profile);
                currentTab === 'Disapproved' && setDisapprovedProfiles([...disapprovedProfiles, profile])
                currentTab === 'Inappropriated' && setInappropriatedProfiles([...inappropriatedProfiles, profile])
                return;
            }

            setDisapprovedProfiles(disapprovedProfiles.filter((disapprovedProfile) => disapprovedProfile.ref !== profile.ref))
            setInappropriatedProfiles(inappropriatedProfiles.filter((inappropriatedProfile) => inappropriatedProfile.ref !== profile.ref))
            setApprovedProfiles([...approvedProfiles, profile])
        } else if (action === 'disapprove') {
            if (checkIfRefExists(profile.ref, 'disapp')) {
                const remove_profile = disapprovedProfiles.filter((item) => item.ref !== profile.ref);
                setDisapprovedProfiles(remove_profile);
                currentTab === 'Approved' && setApprovedProfiles([...approvedProfiles, profile])
                currentTab === 'Inappropriated' && setInappropriatedProfiles([...inappropriatedProfiles, profile])
                return;
            }
            setApprovedProfiles(approvedProfiles.filter((approvedProfile) => approvedProfile.ref !== profile.ref))
            setInappropriatedProfiles(inappropriatedProfiles.filter((inappropriatedProfile) => inappropriatedProfile.ref !== profile.ref))
            setDisapprovedProfiles([...disapprovedProfiles, profile])
        } else {
            if (checkIfRefExists(profile.ref, 'inapp')) {
                const remove_profile = inappropriatedProfiles.filter((item) => item.ref !== profile.ref);
                setInappropriatedProfiles(remove_profile);
                currentTab === 'Approved' && setApprovedProfiles([...approvedProfiles, profile])
                currentTab === 'Disapproved' && setDisapprovedProfiles([...disapprovedProfiles, profile])
                return;
            }
            setApprovedProfiles(approvedProfiles.filter((approvedProfile) => approvedProfile.ref !== profile.ref))
            setDisapprovedProfiles(disapprovedProfiles.filter((disapprovedProfile) => disapprovedProfile.ref !== profile.ref))
            setInappropriatedProfiles([...inappropriatedProfiles, profile])
        }
    }

    const saveChanges = async () => {
        setLoading(true);
        let params = { approve: approvedProfiles, disapprove: disapprovedProfiles, inappropriate: inappropriatedProfiles, editedImages: [], reviewPassed: [], type: 'auto_curate' }

        // 🔹 Calculate payload size
        const jsonString = JSON.stringify(params);

        // Bytes (most accurate)
        const bytes = new TextEncoder().encode(jsonString).length;

        // Human readable
        const kb = (bytes / 1024).toFixed(2);
        const mb = (bytes / (1024 * 1024)).toFixed(2);

        console.log("Payload size:", bytes, "bytes");
        console.log("Payload size:", kb, "KB");
        console.log("Payload size:", mb, "MB");

        console.log("approve count", approvedProfiles.length);
        console.log("disapprove count", disapprovedProfiles.length);
        console.log("inappropriate count", inappropriatedProfiles.length);
        
        let response = await authorizedHttpPost(urls.APPROVE_DISAPPROVE, params);
        if (response.status) {
            setApprovedProfiles([])
            setDisapprovedProfiles([])
            setInappropriatedProfiles([])
            fetchAutoCuratedFeed();
            clearSelectedPhotoset();
        }
        setLoading(false);
        window.scrollTo({ top: 0, behavior: 'auto' });
    };

    const goToPage = (pageNumber) => {
        if (pageNumber <= totalPages.current && pageNumber >= 1) {
            setPage(pageNumber);
        }
        setDisplayPageModal(false);
    }

    return (
        <div>
            {loading && <Loader />}
            {showCropImage ? <CropImage photo={cropPhoto} closeModal={() => setShowCropImage(false)} saveCroppedImage={saveCroppedImage} /> : null}
            {feedData.length === 0 && !loading && <EmptyView />}
            {displayPageModal && <PageModal goToPage={goToPage} page={page} closeModal={() => setDisplayPageModal(false)} />}
            <LeftNav handleLeftNavAppChange={handleLeftNavAppChange} tabName={'Feed Auto Curated'} />
            <div className="auto-feed-header">
                <div className="auto-page-number" onClick={() => setDisplayPageModal(true)}>
                    <span className="auto-header-span active">{page}</span>
                    <span className="auto-header-span active">{totalPages.current}</span>
                </div>
                <div className="auto-profile-state-header">
                    <span className={`${currentTab === 'Approved' ? 'auto-header-span active' : 'auto-header-span'}`} onClick={() => handleTabChange('Approved')}>Approved</span>
                    <span className={`${currentTab === 'Disapproved' ? 'auto-header-span active' : 'auto-header-span'}`} onClick={() => handleTabChange('Disapproved')}>Disapproved</span>
                    <span className={`${currentTab === 'Inappropriated' ? 'auto-header-span active' : 'auto-header-span'}`} onClick={() => handleTabChange('Inappropriated')}>Inappropriated</span>
                </div>
                <div className="auto-date-filter">
                    <span className="auto-date-label">Date</span>
                    <input
                        type="date"
                        className="auto-date-input"
                        value={selectedDate}
                        onChange={handleDateChange}
                    />
                    {selectedDate && (
                        <button type="button" className="auto-action-button" onClick={handleDateReset}>Reset</button>
                    )}
                </div>
            </div>
            <div className="auto-profile-container-main">
                {
                    feedData.map((profile, index) => (
                        <div className="auto-profile-div">
                            <p className="auto-profile-details">
                                {console.log(profile.is_verified)}
                                {console.log(profile.marital_status_v1)}
                                {profile.first_name}
                                {profile.is_verified && <img src={verified_icon} className="verifiedTick" alt="verified tick" />} /
                                {profile.gender === 'Male' ? 'M' : 'F'} /
                                {profile.age} /
                                {profile.marital_status_v1?.name || 'N/A'} /
                                {profile.language} /
                                {profile.location_str} /
                                {convertTimestampToFormattedDate(profile.application_date)} /
                                {profile.phone_code}
                            </p>
                            <div className="auto-display-flex">
                                <div>
                                    <div className="auto-profile-container">
                                        {profile.photos.map((photo, photoIndex) => (
                                            <div className="auto-image-container"
                                                onDragStart={(e) => dragStart(e, photoIndex, photo.photo, 'photos')}
                                                onDragEnter={(e) => dragEnter(e, photoIndex)}
                                                onDragEnd={() => dropImage(profile.ref, 'photos')}
                                            >

                                                {
                                                    photo.hive_deleted ? <div className={`tooltip ${photo.hive_deleted && photo.can_save ? 'color-green' : 'color-red'}`}>
                                                        {photo.hive_deleted && photo.can_save ? "Restored" : "Deleted"}
                                                        <span className="tooltiptext">{photo.hive_delete_reason}</span>
                                                    </div> : <div className="auto-visibiliy-hidden">Deleted</div>
                                                }
                                                <img key={photoIndex} src={getSafeMediaUrl(photo.photo, no_image_available)} alt="profile" width={150} height={150} className="auto-profile-image" onError={(e) => e.target.src = no_image_available} />
                                                <div className="auto-crop-icon-div" onClick={() => showImageCrop(photo.photo, photoIndex, profile.ref, 'photos', index)}>
                                                    <img src={crop_icon} width={15} height={15} />
                                                </div>
                                                <div className="auto-delete-icon-div">
                                                    {
                                                        photo.hive_deleted ? <img src={restore} width={15} height={15} onClick={() => restoreImage(index, photoIndex, 'photos')} /> :
                                                            <img src={delete_image} width={15} height={15} onClick={() => deleteImages(index, photoIndex, 'photos')} />
                                                    }
                                                </div>
                                                <div className={isIpad ? `${photo.selected ? 'auto-heart-div-ipad auto-heart-div-selected' : 'auto-heart-div-ipad'}` : `${photo.selected ? 'auto-heart-div auto-heart-div-selected' : 'auto-heart-div'}`}
                                                    onClick={() => setPhotoSelected(index, photoIndex, 'photos')}
                                                >
                                                    {
                                                        photo.selected && <img src={heart} width={15} height={15} />
                                                    }
                                                </div>
                                                <div className={isIpad ? "auto-chrome-icon-div-ipad" : "auto-chrome-icon-div"}>
                                                    <img src={chrome_icon} onClick={() => openGoogleImages(photo.photo)} width={17} height={17} />
                                                </div>
                                            </div>
                                        ))}
                                        <SelectedView className="auto-selected-photoset" id={`${profile.ref}-${index}-photos`} selected={photosetSelected} onClick={selectphotoSet}></SelectedView>
                                    </div>

                                    {/* new section starts here */}
                                    {profile.hive_curated_photos?.length > 0 && <div className="hive-curated-border">
                                        Hive Curated Photos
                                        <div className="auto-profile-container">
                                            {profile.hive_curated_photos.map((photo, photoIndex) => (
                                                <div className="auto-image-container-hive-curated"
                                                    onDragStart={(e) => dragStart(e, photoIndex, photo.photo, 'hive_curated_photos')}
                                                    onDragEnter={(e) => dragEnter(e, photoIndex)}
                                                    onDragEnd={() => dropImage(profile.ref, 'hive_curated_photos')}
                                                >

                                                    {
                                                        photo.hive_deleted ? <div className={`tooltip ${photo.hive_deleted && photo.can_save ? 'color-green' : 'color-red'}`}>
                                                            {photo.hive_deleted && photo.can_save ? "Restored" : "Deleted"}
                                                            <span className="tooltiptext">{photo.hive_delete_reason}</span>
                                                        </div> : <div className="auto-visibiliy-hidden">Deleted</div>
                                                    }
                                                    <img key={photoIndex} src={getSafeMediaUrl(photo.photo, no_image_available)} alt="profile" width={150} height={150} className="auto-profile-image" onError={(e) => e.target.src = no_image_available} />
                                                    <div className="auto-crop-icon-div" onClick={() => showImageCrop(photo.photo, photoIndex, profile.ref, 'hive_curated_photos', index)}>
                                                        <img src={crop_icon} width={15} height={15} />
                                                    </div>
                                                    <div className="auto-delete-icon-div">
                                                        {
                                                            photo.hive_deleted ? <img src={restore} width={15} height={15} onClick={() => restoreImage(index, photoIndex, 'hive_curated_photos')} /> :
                                                                <img src={delete_image} width={15} height={15} onClick={() => deleteImages(index, photoIndex, 'hive_curated_photos')} />
                                                        }
                                                    </div>
                                                    <div className={isIpad ? `${photo.selected ? 'auto-heart-div-ipad auto-heart-div-selected' : 'auto-heart-div-ipad'}` : `${photo.selected ? 'auto-heart-div auto-heart-div-selected' : 'auto-heart-div'}`}
                                                        onClick={() => setPhotoSelected(index, photoIndex, 'hive_curated_photos')}
                                                    >
                                                        {
                                                            photo.selected && <img src={heart} width={15} height={15} />
                                                        }
                                                    </div>
                                                    <div className={isIpad ? "auto-chrome-icon-div-ipad" : "auto-chrome-icon-div"}>
                                                        <img src={chrome_icon} onClick={() => openGoogleImages(photo.photo)} width={17} height={17} />
                                                    </div>
                                                </div>
                                            ))}
                                            <SelectedView className="auto-selected-photoset" id={`${profile.ref}-${index}-hive_curated_photos`} selected={photosetSelected} onClick={selectphotoSet}></SelectedView>
                                        </div>
                                    </div>}
                                </div>

                                <div>
                                    <div className="auto-visibiliy-hidden">Deleted</div>
                                    {(profile.selfie_url || profile.gesture_url) && <img src={getSafeMediaUrl(profile.selfie_url || profile.gesture_url, no_image_available)} width={150} height={150} className="auto-profile-image" />}
                                </div>

                                <div className="auto-action-button-div">
                                    {currentTab !== 'Approved' && <button onClick={() => handleAction(profile, 'approve')} className={checkIfRefExists(profile.ref, 'approve') ? "auto-action-button auto-approve-active" : "auto-action-button"}>A</button>}
                                    {currentTab !== 'Disapproved' && <button onClick={() => handleAction(profile, 'disapprove')} className={checkIfRefExists(profile.ref, 'disapp') ? "auto-action-button auto-disapprove-active" : "auto-action-button"}>D</button>}
                                    {currentTab !== 'Inappropriated' && <button onClick={() => handleAction(profile, 'inapp')} className={checkIfRefExists(profile.ref, 'inapp') ? "auto-action-button auto-inapp-active" : "auto-action-button"}>I</button>}
                                    <p>{profile.ref}</p>
                                    <ShareRefControl
                                        refValue={profile.ref}
                                        sourceTab={sharingSourceTabByAutoTab[currentTab]}
                                        compact={true}
                                    />
                                </div>
                            </div>
                            <hr />
                        </div>
                    ))
                }
            </div>
            <div className="auto-page-control">
                {
                    feedData.length > 0 &&
                    <div className="auto-jusitfy-center">
                        {page === 1 ? <img alt="previous_inctive" src={previous_inctive} className="cursorPointer" /> : <img alt="previous_active" src={previous_active} onClick={() => handlePageChange('previous')} className="cursorPointer" />}
                        {page === totalPages.current ? <img alt="next_inactive" className="nextInctiveStyle" src={next_inactive} onClick={() => handlePageChange('next')} /> : <img className="nextInctiveStyle" alt="next_active" src={next_active} onClick={() => handlePageChange('next')} />}
                    </div>
                }
                {
                    feedData.length > 0 &&
                    <div>
                        <BaseButton onClick={() => saveChanges()}>Save</BaseButton>
                    </div>
                }
            </div>

        </div>
    );
};

export default FeedAutoCurated;
